module.exports = __webpack_public_path__ + "static/forms-multiple-fields-next-dont-ddc0a8044bc299c6eb9376accb2632ca.png";